import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetAllShiftsUseCaseInterface } from 'domain/usecases';

export class RemoteGetAllShifts implements GetAllShiftsUseCaseInterface {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetAllShiftsUseCaseInterface.Result>,
  ) {}

  async execute(): Promise<GetAllShiftsUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: this.url,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
